module.exports = __webpack_public_path__ + "static/media/ihs.11e61285.svg";